/**
 * Configuracao centralizada de versao do frontend
 * Centraliza informacoes de versao para uso em componentes e testes
 * Gerado/atualizado pelo script de build e pelo script version:bump
 *
 * O campo `version` deve sempre corresponder ao campo `version` do frontend/package.json
 * O campo `buildDate` e atualizado pelo processo de build com a data UTC da execucao
 */
export const APP_VERSION = {
  version: '2.2.1',
  name: 'equilibra-frontend',
  buildDate: '2026-09-08T18:40:09Z'
}